import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconStyled = styled(FontAwesomeIcon)`
  margin-right: 7px;
`;

export default IconStyled;
